import { Box, Typography } from "@husqvarna/ui-core";
import { FormattedMessage, FormattedNumber } from "react-intl";
import { AmountUnit, FinancingOption } from "../../../project/models/Enums";
import {Proposal} from "../../../project/models/Proposal";
import { Token } from "@husqvarna/ui-core/dist/design-tokens/colors";
import { getProposalProductsTotal } from "../../utils/proposalPriceUtils";

type ProposalPriceProps = {
    proposal: Proposal;
    currency: string;
    discountUnit: AmountUnit;    
    discount: number | undefined;
    financialOption: FinancingOption;
    leasingAmount: number | undefined;
}

const ProposalPrice = ({
    proposal,
    currency,
    discountUnit,
    discount,
    financialOption,
    leasingAmount,
}: ProposalPriceProps) => {
  
    const  hasDiscount = discount != null && discount > 0;
    const getAllProductsPrice = () : number => {
        if(proposal.mowers == null) {
            return 0;
        }
        let proposalProducts = proposal.mowers;
        if (proposal.referenceStations?.length) {
            proposalProducts = [...proposalProducts, ...proposal.referenceStations];
        }

        return getProposalProductsTotal(proposalProducts);
    }

    const renderDiscountedPrice = () => {
        if (financialOption === FinancingOption.Leasing && leasingAmount && leasingAmount > 0) {
            return renderPriceText("SuccessGreen", "Subtitle1", leasingAmount, currency, true);
        } else if (financialOption === FinancingOption.Leasing) {
            return <Typography
                variant="Subtitle1"
                color="Grey600"
                text="-"
                tag="p"
            />
        }

        const price = getAllProductsPrice();
        if (price > 0) {
            const validatetDiscount = !hasDiscount ? 0 : discount ?? 0;
            const finishedDiscount = discountUnit === AmountUnit.Currency ? validatetDiscount : ((validatetDiscount / 100) * price);
            return renderPriceText("SuccessGreen", "Subtitle1", price - finishedDiscount, currency, false);
        }

        return <Typography
                variant="Subtitle1"
                color={'Grey600'}
                text="-"
                tag="p"
            />
    }

    const renderPriceText = (textColor: Token, variant: "Body1" | "Subtitle1", price: number, currency: string, isLeasing: boolean) => {
        return <Typography tag='p'>
                <Typography
                    tag="span"
                    variant={variant}
                    color={textColor}>
                    <FormattedNumber
                        value={price}
                        maximumFractionDigits={0}
                    />
                </Typography>
                {' '}
                <Typography tag="span" variant="Microcopy" color="Grey600" text={currency} />
                {isLeasing && (
                    <Typography tag='span' variant="Microcopy" color="Grey600">
                        <FormattedMessage id="proposal.leasing.perMonth" defaultMessage=" /month" />
                    </Typography>
                )}
            </Typography>
    }
    
    return (
        <Box>
            {renderDiscountedPrice()}
        </Box>
    );
};

export default ProposalPrice;
